import { trycatchHandling, trycatchAsyncHandling } from '@/libs/utils/index'
export default {
  install: (app: any, options: object) => {
    app.config.globalProperties.$trycatch = trycatchHandling
    app.config.globalProperties.$trycatchAsync = trycatchAsyncHandling
  },
}
